import ErrorHandler from './ErrorHandler.container';
export default ErrorHandler;
